import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";

const Elogin = () => {
    const [identifier, setIdentifier] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");

        if (!identifier || !password) {
            setError("Please enter both email/username and password.");
            return;
        }

        try {
            const res = await fetch("/api/eblogin", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ identifier, password }),
            });

            const data = await res.json();

            if (!data.success) {
                setError(data.message || "Invalid credentials.");
                return;
            }

            // ✅ Log user details for debugging
            console.log("✅ Logged in user details:", data.user);

            // ✅ Save user object
            localStorage.setItem("user", JSON.stringify(data.user));

            // ✅ Also store individual fields for easy access
            localStorage.setItem("org_id", data.user.org_id);
            localStorage.setItem("user_id", data.user.user_id);
            localStorage.setItem("user_name", data.user.user_name);
            localStorage.setItem("role", data.user.role);
            localStorage.setItem("email", data.user.user_email_id);

            if (data.user.role === "superadmin") {
                navigate("/create-organzation");
            }
            else if (data.user.role === "admin") {
                navigate("/organization");
            }
            else if (data.user.role === "user") {
                navigate("/employeeprofile");
            }
            else {
                setError("Invalid user role. Contact admin.");
                return;
            }

        } catch (err) {
            console.error("Login error:", err);
            setError("Server error. Please try again later.");
        }
    };

    return (
        <div className="elogin-container">
            <div className="elogin-card">
                <h2 className="elogin-title">Login</h2>

                <form onSubmit={handleLogin} className="elogin-form">
                    <div className="elogin-field">
                        <label>Email or Username</label>
                        <input
                            type="text"
                            placeholder="Enter email or username"
                            value={identifier}
                            onChange={(e) => setIdentifier(e.target.value)}
                        />
                    </div>

                    <div className="elogin-field">
                        <label>Password</label>
                        <input
                            type="password"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    {error && <p className="elogin-error">{error}</p>}

                    <button type="submit" className="elogin-btn">
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Elogin;
